module.exports = __webpack_public_path__ + "static/media/rabbit-fast.50b90c58.svg";